import {
  makeStyles,
  Container,
  Modal,
  Grid,
  Typography,
} from "@material-ui/core";
import { theme } from "../constants/theme";
import { CancelButton, PrimaryButton } from "../components-atoms";
export const NoItemLeftModal = (props: any) => {
  const classes = useStyles();

  return (
    <Modal
      open={props.visible}
      onClose={props.onClose}
      className={classes.modal}
    >
      <Container className={classes.modalContainer}>
        <Grid container spacing={1}></Grid>
        <Grid item className={classes.titleSection}>
          <Typography
            data-automation="ordered-item-not-available-modal"
            variant="h6"
            component="h6"
            color="textPrimary"
          >
            Reject order
          </Typography>
        </Grid>
        <Grid item className={classes.bodySection}>
          <Grid item container direction="row">
            <Typography
              variant="body2"
              component="p"
              className={classes.mt8}
              color="textPrimary"
            >
              There are no active products remaining in this order to process.
              Do you want to reject the entire order?
            </Typography>
          </Grid>
        </Grid>

        <Grid item container xs={12} justifyContent="flex-end">
          <CancelButton onClick={props.onClose} />
          <PrimaryButton
            title="Reject"
            data-automation="reject-order-submit-button"
            onClick={props.onRejectOrderPressed}
          />
        </Grid>
      </Container>
    </Modal>
  );
};
const useStyles = makeStyles({
  modal: { alignItems: "center", justifyContent: "center" },
  modalContainer: {
    backgroundColor: "white",
    maxWidth: "480px",
    boxShadow:
      "0px 6px 36px rgba(0, 0, 0, 0.15), 0px 2.21728px 14.2392px rgba(0, 0, 0, 0.111884), 0px 0.93179px 6.99399px rgba(0, 0, 0, 0.0997219), 0px 0.37078px 3.36556px rgba(0, 0, 0, 0.0894965), 0px 0.120827px 1.42249px rgba(0, 0, 0, 0.0753326), 0px 0.0225271px 0.422798px rgba(0, 0, 0, 0.0508791)",
    borderRadius: "20px",
    padding: "24px",
    margin: "0",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },

  titleSection: {
    marginBottom: "8px",
  },
  bodySection: {
    marginBottom: "24px",
  },
  rejectButton: {
    border: `1px solid ${theme.palette.primary.main}`,
    color: "rgba(255, 255, 255, 1)",
    textTransform: "none",
    paddingRight: 16,
    paddingLeft: 12,
  },
  cancelButton: {
    marginRight: "8px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  mt8: {
    marginTop: 8,
  },
});
